import type { IUserOrgResponse } from '@/app-package';

import axios from 'axios';

const getSupraLockboxGrantees = async (
  lockboxId: string,
  includePendingGrantees: boolean,
) => {
  const { data } = await axios.get<IUserOrgResponse['users']>(
    `/supra/grantees/${lockboxId}?includePendingGrantees=${includePendingGrantees}`,
  );

  return data;
};

export default getSupraLockboxGrantees;
